<div class="row">

  <div class="col-lg-6">
    <h3>Service Areas</h3>
  </div>

  <div class="col-lg-6">
    @if (!isEditMode) {
      <button type="button"
        class="btn btn-primary btn-wrap pull-right"
        (click)="toggleEdit()">
        Edit
      </button>
    }
    @if (isEditMode) {
      <button type="button"
        class="btn btn-default btn-wrap pull-right"
        (click)="toggleEdit()">
        Close
      </button>
    }
    @if (isEditMode) {
      <button type="button"
        class="btn btn-primary btn-wrap pull-right"
        (click)="save()">
        Update
      </button>
    }
    @if (isEditMode) {
      <button type="button"
        class="btn btn-success btn-wrap pull-right"
        (click)="openAddStateCountiesModal()">
        Add State
      </button>
    }
  </div>

</div>


@if (serviceAreas.length) {
  <div>
    @for (area of serviceAreas; track area) {
      <div class="panel panel-default"
        >
        <div class="panel-heading">
          <h3 class="panel-title">{{area.state.name}}
            @if (isEditMode) {
              <a class="pull-right cursor-pointer"
                (click)="removeState(area.state.id)">
                <img src="/assets/images/remove_state_circle-24px.svg" class = "remove-icon">
              </a>
            }
            @if (isEditMode) {
              <a class="pull-right cursor-pointer"
                (click)="updateAddStateCountiesModal(area.state.id)">
                <img src="/assets/images/add-circle.svg" class = "add-icon">
              </a>
            }
          </h3>
        </div>
        <table class="table">
          <tbody>
            @for (county of area.counties; track county) {
              <tr>
                <td>{{county.name}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
} @else {
  No Data Found
}
